"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardPhaseGroupes_1 = require("./DashboardPhaseGroupes");
var Dashboard = /** @class */function () {
    function Dashboard(data) {
        this.showLoader = true;
        this.phaseGroupes = [];
        this.groupeToDisplay = null;
        if (data != null) {
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var grp = data_1[_i];
                this.phaseGroupes.push(new DashboardPhaseGroupes_1.DashboardPhaseGroupes(grp));
            }
        }
    }
    return Dashboard;
}();
exports.Dashboard = Dashboard;


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Dashboard/Models/Dashboard.ts
// module id = 530
// module chunks = 0